import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { useDispatch } from 'react-redux';
import { setNavTab } from 'modules/status';
import { registerKbUser } from 'modules/account';
import { KEY } from 'utils/constants/storageKey';

/** KB유저 관련 Setting  */
function useKb() {
  const dispatch = useDispatch();
  const location = useLocation();
  const [registeredKbUser, setRegisteredKbUser] = useState(false);

  let searchParams = location.search;
  const inKey = searchParams.includes('inkey');

  if (inKey) {
    searchParams = searchParams.replace(/&/g, '%26');
    searchParams = searchParams.replace(/\+/g, '%2B');
  }

  useEffect(() => {
    // * KB 유저는 inkey로 회원가입  && 재가입 방지
    if (inKey && !registeredKbUser) {
      // * 기존 유저 제거
      localStorage.removeItem(KEY);
      const queryObj = queryString.parse(searchParams);
      // 두피진단 결과 진입시 queryString으로 id도 함께 전달받습니다 (from KB)
      if (queryObj.inkey.includes('&id=')) {
        queryObj.inkey = queryObj.inkey.substring(
          0,
          queryObj.inkey.indexOf('&id='),
        );
      }
      // 1.inkey 로 kb유저 회원가입 후 로그인
      dispatch(
        registerKbUser({
          inKey: queryObj.inkey,
        }),
      );
      setRegisteredKbUser(true);
      // * 두피진단 탭 으로 이동
      dispatch(setNavTab(1));
    }
  }, [registeredKbUser]);
}
export default useKb;
